export const ROUTE_PREFIX_CATEGORIES = 'categories';
export const ROUTE_PREFIX_HASHTAGS = 'hashtags';
export const ROUTE_PREFIX_ARCHIVE = 'archive';
export const ROUTE_PREFIX_TAGS = 'tags';
//# sourceMappingURL=route-prefix.js.map